module.exports = __webpack_public_path__ + "img/202411_09.23ec28af.jpg";